import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushMaskIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 18h18",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			stroke: "none",
			d: "M7 18v-8h10v8",
			opacity: .15
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeDasharray: "2 2",
			d: "M7 10h10M7 10v8M17 10v8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 13,
			r: 2.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "M12 12v2.5"
		})
	]
});
export default SvgBrushMaskIcon;
